import {LoginResult} from '@comm-apps/shared-ui';
import {cad} from "@comm-apps/common";
import UserPreferences = cad.UserPreferences;
import TableState = cad.TableState;
import { UserReqChangeOp } from '../enums/enums';

export interface Auditable {
  updater?: string,
  updateDt?: Date
}

export interface UserRequestData {
  id?: number;
  actionCd?: string;
  statusCd?: string;
  userId?: string;
  applicationCd?: string;
  title?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  imId?: string;
  phone?: string;
  extension?: string;
  phone2?: string;
  address?: string;
  city?: string;
  stateCd?: string;
  zip?: string;
  agent?: boolean;
  agentCompanies?: string;
  primaryCompanyInd?: boolean;
  primaryCompany?: string;
  managerName?: string;
  managerTitle?: string;
  managerEmail?: string;
  managerPhone?: string;
  agreementSigned?: boolean;
  comment?: string;
  roles?: any[];
  tsps?: any[];
  companies?: Company[];
  notifications?: any[];
  plantFacilities?: any[]
  recaptchaToken?: string;
  agentContracts?: string; // QPTM
  actionComment?: string; //transient
}

export interface AccessRequestDocument extends Auditable {
    id?: number;
    accessRequestId?: number;
    envelopeId?: string;
    envelopeUri?: string;
    status?: string;
    fileData?: string;
}

export interface AccessRequestStatusHistory extends Auditable {
  id?: number;
  accessRequestId?: number;
  statusCd?: string;
}

export interface CARUser extends LoginResult {
  loginName?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  preferences?: any;
  roles?: string[];
}

export interface UserPrefs extends UserPreferences {
  dashTableStates?: TableState[];
  
  theme?: string;
  //more stuff here
}

export interface AllUser {
  userId?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string; //doesn't exist on the backend; this is so we can use it as the displayProperty on AutoComplete
}

export interface UserIdName {
  userId?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
}

export interface CodeData {
  id?: number;
  type?: string;
  code?: string;
  description?: string;
  sortOrder?: number;
  enabled?: boolean;
  autoCompleteDescription?: string;
}

export interface CodeDataCheck extends CodeData {
  checked?: boolean;
}

export class Role {
  id?: number;
  roleName?: string;
  roleDescription?: string;
  userId?: string;
  userFullName?: string;
  updater?: string;
  updaterFullName?: string;
  updateDt?: Date;
}

export class Asset {
  code: string;
  name: string;
  roles: AssetRole[];
}

export class AssetRole {
  code: string;
  name: string;
  businessArea: string;
  viewOnly: boolean;
  checked?: boolean;
}

export interface ApplicationConfig {
  id?: number;
  name?: string;
  value?: string;
  type?: string;
}

export class Company {
  id?: number;
  accessRequestId?: number;
  companyName?: string;
  companyId?: string;
  companyDuns?: string;
  //frontend only fields
  prevCompanyName?: string;
  prevCompanyId?: string;
  matchingBAs?: BA[];
}

export class BA {
  baNbr?: string;
  baName?: string;
  baName2?: string;
  baDuns?: string;
  baNbrName?: string; //frontend
}

export interface UserReqChange {
  data: UserRequestData;
  operation: UserReqChangeOp;
}

export interface WebserviceError {
  [key: string]: any;
}

export type AuthGroup = 'READ' | 'WRITE' | 'ADMIN' ;

